document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.categories-filter__form');
  const cards = Array.from(document.querySelectorAll('[data-filter-item]'));
  const budgetHint = document.querySelector('[data-filter-hint="budget"]');

  if (!form || !cards.length) return;

  const parseNumber = (value) => {
    if (value === null || value === undefined) return NaN;
    const trimmed = String(value).trim();
    if (!trimmed) return NaN;
    const n = Number(trimmed.replace(/\s+/g, ''));
    return Number.isFinite(n) ? n : NaN;
  };

  const getCardNumber = (card, name) => parseNumber(card.dataset[name]);

  const roomsMatch = (card, roomsFilter) => {
    if (!roomsFilter) return true;
    const min = getCardNumber(card, 'roomsMin');
    const max = getCardNumber(card, 'roomsMax');
    if (Number.isNaN(min) || Number.isNaN(max)) return true;

    if (roomsFilter === 'studio') return max <= 1;
    if (roomsFilter === '1-2') return min <= 2 && max >= 1;
    if (roomsFilter === '3plus') return max >= 3;
    return true;
  };

  const rangeMatch = (valueMin, valueMax, filterMin, filterMax) => {
    if (Number.isNaN(valueMin) && Number.isNaN(valueMax)) return true;
    const vMin = Number.isNaN(valueMin) ? valueMax : valueMin;
    const vMax = Number.isNaN(valueMax) ? valueMin : valueMax;
    if (!Number.isNaN(filterMin) && vMax < filterMin) return false;
    if (!Number.isNaN(filterMax) && vMin > filterMax) return false;
    return true;
  };

  const hasMedia = (card) => (card.dataset.media || '').toLowerCase().includes('photo');

  const getValues = () => {
    const data = new FormData(form);
    return {
      type: (data.get('type') || '').toString(),
      priceMin: parseNumber(data.get('priceMin')),
      priceMax: parseNumber(data.get('priceMax')),
      areaMin: parseNumber(data.get('areaMin')),
      areaMax: parseNumber(data.get('areaMax')),
      rooms: (data.get('rooms') || '').toString(),
      lease: (data.get('lease') || '').toString(),
      available: (data.get('available') || '').toString(),
      comfortZone: data.get('comfortZone') === '1',
      richMedia: data.get('richMedia') === '1',
      energy: (data.get('energy') || '').toString(),
      eco: (data.get('eco') || '').toString(),
      noise: (data.get('noise') || '').toString(),
      safety: (data.get('safety') || '').toString(),
    };
  };

  const applyFilters = () => {
    const v = getValues();

    cards.forEach((card) => {
      let visible = true;

      if (v.type && card.dataset.type !== v.type) visible = false;

      if (
        !rangeMatch(
          getCardNumber(card, 'priceMin'),
          getCardNumber(card, 'priceMax'),
          v.priceMin,
          v.priceMax,
        )
      ) visible = false;

      if (
        !rangeMatch(
          getCardNumber(card, 'areaMin'),
          getCardNumber(card, 'areaMax'),
          v.areaMin,
          v.areaMax,
        )
      ) visible = false;

      if (!roomsMatch(card, v.rooms)) visible = false;

      if (v.lease && card.dataset.lease !== v.lease) visible = false;
      if (v.available && card.dataset.available !== v.available) visible = false;

      if (v.comfortZone && card.dataset.comfort !== 'true') visible = false;

      if (v.richMedia && !hasMedia(card)) visible = false;

      if (v.energy && card.dataset.energy !== v.energy) visible = false;
      if (v.eco && card.dataset.eco !== v.eco) visible = false;
      if (v.noise && card.dataset.noise !== v.noise) visible = false;
      if (v.safety && card.dataset.safety !== v.safety) visible = false;

      card.classList.toggle('is-filter-hidden', !visible);
    });
  };

  if (budgetHint) {
    const typeSelect = form.querySelector('[name="type"]');
    const updateBudgetHint = () => {
      const currentType = typeSelect instanceof HTMLSelectElement ? typeSelect.value : '';
      const subset = cards.filter((card) => !currentType || card.dataset.type === currentType);

      if (!subset.length) {
        budgetHint.textContent = '';
        return;
      }

      let min = Infinity;
      let max = -Infinity;

      subset.forEach((card) => {
        const cMin = getCardNumber(card, 'priceMin');
        const cMax = getCardNumber(card, 'priceMax');
        if (!Number.isNaN(cMin)) min = Math.min(min, cMin);
        if (!Number.isNaN(cMax)) max = Math.max(max, cMax);
      });

      if (!Number.isFinite(min) || !Number.isFinite(max)) {
        budgetHint.textContent = '';
        return;
      }

      budgetHint.textContent = `Рекомендованный диапазон: $${Math.round(min).toLocaleString()}–$${Math.round(max).toLocaleString()}`;
    };

    form.addEventListener('change', updateBudgetHint);
    updateBudgetHint();
  }

  form.addEventListener('input', () => {
    applyFilters();
  });

  form.addEventListener('change', () => {
    applyFilters();
  });

  const resetBtn = form.querySelector('[data-filter-reset]');
  resetBtn?.addEventListener('click', () => {
    form.reset();
    applyFilters();
  });

  applyFilters();
});

